export default "__VITE_ASSET__CgMABCzB__"